export var DecisionState;
(function (DecisionState) {
    DecisionState[DecisionState["Default"] = 0] = "Default";
    DecisionState[DecisionState["Approved"] = 1] = "Approved";
    DecisionState[DecisionState["Rejected"] = 2] = "Rejected";
    DecisionState[DecisionState["ClosedWithoutResult"] = 3] = "ClosedWithoutResult";
})(DecisionState || (DecisionState = {}));
